<template>
  <el-dialog
    title="选择商品"
    :visible.sync="visible"
    width="70%"
    custom-class="goods-list"
    :before-close="beforeClose"
  >
    <div class="top">
      <el-search
        :formProp="formData"
        @resetForm="resetForm"
        :selectClear="true"
        :spoNum="3"
        @search="search"
      >
        <template slot="search">
          <el-input
            v-model.trim="formData.skuTitle"
            clearable
            placeholder="请输入商品标题模糊查询"
            searchLabel="商品标题"
          ></el-input>
          <el-input
            v-model.trim="formData.skuId"
            clearable
            placeholder="请输入商品编码精确查询"
            searchLabel="商品编码"
          ></el-input>
          <el-input
            v-model.trim="formData.extSkuId"
            clearable
            placeholder="请输入商家编码精确查询"
            searchLabel="商家编码"
          ></el-input>
          <el-input
            v-model.trim="formData.brandName"
            clearable
            placeholder="请输入品牌模糊查询"
            searchLabel="品牌"
          ></el-input>
          <el-select
            v-model="formData.cateryCode"
            :disabled="true"
            placeholder="请选择商品分类"
            searchLabel="商品分类"
          >
            <el-option
              v-for="item in cateryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            v-model.trim="formData.shopName"
            clearable
            placeholder="请输入店铺名称模糊查询"
            searchLabel="店铺名称"
          ></el-input>
          <!-- <el-select
            v-model="formData.shopName"
            clearable
            placeholder="请选择店铺"
            searchLabel="店铺名称"
            value-key="value"
          >
            <el-option
              v-for="item in shopList"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select> -->
        </template>

        <el-input
          slot="searchItem1"
          v-model.trim="formData.skuTitle"
          clearable
          placeholder="请输入商品标题模糊查询"
          searchLabel="商品标题"
        ></el-input>
        <el-input
          slot="searchItem2"
          v-model.trim="formData.skuId"
          clearable
          placeholder="请输入商品编码精确查询"
          searchLabel="商品编码"
        ></el-input>
        <el-input
          slot="searchItem3"
          v-model.trim="formData.extSkuId"
          clearable
          placeholder="请输入商家编码精确查询"
          searchLabel="商家编码"
        ></el-input>
        <el-input
          slot="searchItem4"
          v-model.trim="formData.brandName"
          clearable
          placeholder="请输入品牌模糊查询"
          searchLabel="品牌"
        ></el-input>
        <el-select
          slot="searchItem5"
          v-model="formData.cateryCode"
          :disabled="true"
          placeholder="请选择商品分类"
          searchLabel="商品分类"
        >
          <el-option
            v-for="item in cateryList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          slot="searchItem6"
          v-model.trim="formData.shopName"
          clearable
          placeholder="请输入店铺名称模糊查询"
          searchLabel="店铺名称"
        ></el-input>
        <!-- <el-select
          slot="searchItem6"
          v-model="formData.shopName"
          clearable
          placeholder="请选择店铺"
          searchLabel="店铺名称"
        >
          <el-option
            v-for="item in shopList"
            :key="item.value"
            :label="item.label"
            :value="item.label"
          ></el-option>
        </el-select> -->
      </el-search>
    </div>
    <div class="ccui-multifunctional-table-wrapper">
      <el-table
        v-if="tableHack"
        ref="multipleTable"
        v-loading="loading"
        :data="tableData"
        :fit="true"
        border
        class="ccui-multifunctional-table"
        @header-dragend="tableTitleWidth"
        :min-height="9999"
        :max-height="99999"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="50"
        />
        <el-table-column
          label="商品标题"
          align="left"
          min-width="250px"
          fixed="left"
        >
          <template slot-scope="{ row }">
            <div class="goods-image">
              <!-- <el-image :src="row.skuMainPic" fit="cover">
                <span slot="error" class="error-img">暂无图片</span>
              </el-image> -->
              <img :src="row.skuMainPic" alt="暂无图片" />
              <div
                class="goods-info"
                style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >
                <p :title="row.skuTitle">{{ row.skuTitle }}</p>
                <p><span>品牌：</span>{{ row.brandName }}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="left" min-width="170px">
          <template slot-scope="{ row }">
            <div class="goods-info">
              <p>
                <span>商品编码：</span>
                <span :title="row.skuId">{{ row.skuId }}</span>
              </p>
              <p>
                <span>商家编码：</span>
                <span :title="row.extSkuId">{{ row.extSkuId }}</span>
              </p>
              <p>
                <span>计量单位：</span
                ><span :title="row.unitName">{{ row.unitName }}</span>
              </p>
              <p>
                <span>税控编码：</span>
                <span :title="row.taxCode">{{ row.taxCode }}</span>
              </p>
              <p>
                <span>商品税率：</span>
                <span :title="row.tax">{{ row.tax }}%</span>
              </p>
            </div>
          </template>
        </el-table-column>
        <template v-for="(table, index) in tableThead">
          <el-table-column
            v-if="table.checked"
            :fixed="table.fixed || false"
            :type="table.type"
            :key="index"
            :label="table.label"
            :min-width="table.width"
            :prop="table.prop"
            :filters="table.filters"
            :align="table.align"
            :header-align="table.headerAlign || 'left'"
            :formatter="table.formatter"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">
              <span
                style="text-align: right;width: 100%;"
                v-if="table.prop == 'salePrice'"
                >{{
                  row.salePrice ? "￥" + row.salePrice.toFixed(2) : "-"
                }}</span
              >
              <span
                style="text-align: right;width: 100%;"
                v-else-if="table.prop == 'marketPrice'"
              >
                {{
                  row.marketPrice ? "￥" + row.marketPrice.toFixed(2) : "-"
                }}</span
              >
              <span v-else>{{ row[table.prop] }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="120px" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" type="text" @click="handleClick(row)">
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="ccui-table-footer" v-if="totalNum > 0">
        <div id="ccui-paging">
          <el-pagination
            :total="totalNum"
            :page-size="getLocalPageSize()"
            :current-page="formDataSearch.pageNo"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getSessionItem } from "@/config/utils";
import {
  querySkuIsCheckList
  // getShopSupplierList
} from "@/app/inquiry/api/all";
export default {
  name: "",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curGoods: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      shopList: [],
      cateryList: [],
      formData: {
        cateryCode: "",
        pageNo: 1,
        pageSize: this.getLocalPageSize()
      },
      formDataSearch: {
        cateryCode: "",
        pageNo: 1,
        pageSize: this.getLocalPageSize()
      },
      tableHack: true,
      loading: false,
      tableData: [],
      tableThead: [
        {
          label: "企业销售价(元)",
          prop: "salePrice",
          width: "120",
          checked: true,
          align: "right"
        },
        {
          label: "市场价(元)",
          prop: "marketPrice",
          width: "120",
          checked: true,
          align: "right"
        },
        {
          label: "商品分类",
          prop: "cateryName",
          width: "220",
          checked: true,
          align: "left"
        },
        {
          label: "店铺名称",
          prop: "shopName",
          width: "220",
          checked: true,
          align: "left"
        }
      ],
      totalNum: 0,
      searchForm: {}
    };
  },

  components: {},

  computed: {
    visible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      }
    }
  },

  beforeMount() {},

  mounted() {},

  methods: {
    beforeClose() {
      this.visible = false;
      this.resetForm();
    },
    async getShopSupplierList() {
      // try {
      //   const params = {
      //     supplierId: this.curGoods.supplierCode
      //   };
      //   const res = await getShopSupplierList(params);
      //   if (res.data.code !== "0") return;
      //   const { data = [] } = res.data;
      //   this.shopList = data.map(function({ shopId, shopName }) {
      //     return {
      //       value: shopId,
      //       label: shopName
      //     };
      //   });
      //   console.log(
      //     "🚀 ~ this.shopList=data.map ~ this.shopList:",
      //     this.shopList
      //   );
      // } catch (error) {
      //   console.log("🚀 ~ getShopSupplierList ~ error:", error);
      // }
    },
    dialogSubmit() {
      console.log("🚀 ~ dialogSubmit ~ dialogSubmit:");
    },
    async queryGoodsList() {
      try {
        const params = {
          ...this.formData,
          ...this.formDataSearch,
          supplierId: this.curGoods.supplierCode
        };
        this.loading = true;
        const res = await querySkuIsCheckList(params);
        this.loading = false;
        if (res.data.code == "0") {
          this.tableData = res.data.data.rows;
          this.totalNum = res.data.data.recordsTotal;
        }
      } catch (error) {
        this.loading = false;
        console.log("🚀 ~ queryGoodsList ~ error:", error);
      }
    },
    resetForm() {
      // console.log("🚀 ~ resetForm ~ resetForm:");
      this.formData = {
        cateryCode: ""
      };
      this.formDataSearch = {
        cateryCode: this.curGoods.caterycode
      };
      this.formData.cateryCode = this.curGoods.caterycode;
      console.log(this.curGoods, "🚀 ~ curGoods ~ resetForm:");
      console.log(this.formData, "🚀 ~ formData ~ resetForm:");

      this.formData.pageNo = 1;
    },
    search(searchData) {
      if (this.loading) return;
      searchData.cateryCode = this.formData.cateryCode;
      this.formData = JSON.parse(JSON.stringify(searchData));
      this.formDataSearch = JSON.parse(JSON.stringify(searchData));
      this.formData.pageNo = 1;
      this.queryGoodsList();
    },
    getLocalPageSize() {
      return getSessionItem("pageSize", this.tableList.inventoryInbound) || 10;
    },
    tableTitleWidth(newWidth, oldWidth, column) {
      // for (let i = 0; i < this.tableThead.length; i++) {
      //   if (this.tableThead[i].label === column.label) {
      //     this.tableThead[i].width = newWidth;
      //   }
      // }
      // this.tableHack = false;
      // this.$nextTick(() => {
      //   this.tableHack = true;
      // });
    },
    handlePrev() {},
    // 下一页
    handleNext() {},
    handleSizeChange(val) {
      this.formDataSearch.pageNo = 1;
      this.formDataSearch.pageSize = val;
      this.queryGoodsList();
    },
    // 当前页码更改
    handleCurrentChange(val) {
      // 跳转翻页都会调这个方法
      this.formDataSearch.pageNo = val;
      this.queryGoodsList();
    },
    handleClick(row) {
      const newData = {
        ...this.curGoods,
        newSkuId: row.skuId,
        newSkuName: row.skuTitle,
        newTax: row.tax,
        tax: row.tax,
        newTaxFee: row.taxFee,
        shopName: row.shopName,
        shopId: row.shopId,
        finalQuote: row.salePrice
      };
      this.visible = false;
      this.$emit("replace", newData);
    }
  },

  watch: {
    // visible(value) {
    //   if (value) {
    //     this.queryGoodsList();
    //   }
    // },
    curGoods(data) {
      console.log("🚀 ~ curGoods ~ data:", data);
      const { cateryname, caterycode } = data;
      this.cateryList = [
        {
          value: caterycode,
          label: cateryname
        }
      ];
      this.$set(this.formData, "cateryCode", caterycode);
      this.$set(this.formDataSearch, "cateryCode", caterycode);
      this.getShopSupplierList();
      this.queryGoodsList();
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .goods-list {
  .el-dialog__body {
    height: 70vh;
    .goods-image {
      width: 100%;
      display: flex;
      align-items: center;
      img {
        width: 56px;
        height: 56px;
      }
      .goods-info {
        flex: 1;
        padding-left: 5px;
      }
    }
    .goods-info {
      width: 100%;
      p {
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        display: block;
      }
    }
  }
}
/deep/ .ccui-multifunctional-table-wrapper .el-table tbody .cell {
  height: 120px;
  display: flex;
  align-items: center;
}
/deep/ .top {
  .el-form {
    .el-form-item:last-child {
      margin-bottom: 16px;
    }
    .el-row {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
}
</style>
